import { render, staticRenderFns } from "./grid-actions.vue?vue&type=template&id=0f8cfc7a&"
import script from "./grid-actions.ts?vue&type=script&lang=js&"
export * from "./grid-actions.ts?vue&type=script&lang=js&"
import style0 from "./grid-actions.vue?vue&type=style&index=0&id=0f8cfc7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports